import { Component } from '@angular/core';
import { ToastController, NavController, LoadingController, AlertController, Platform, NavParams } from 'ionic-angular';
import { BackgroundMode } from '@ionic-native/background-mode';
import { LocalNotifications } from '@ionic-native/local-notifications';

import { globalDefines } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { CheckProvider } from '../../providers/check/check';
import { NotificationProvider } from '../../providers/notification/notification';
import { TimetableProvider } from '../../providers/timetable/timetable';
import { UserProvider } from '../../providers/user/user';
import { Role } from '../../models/roles';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  lastTimetable;
  pauseEnabled;
  resumeEnabled;
  selectedTimetable;
  startEnabled;
  stopEnabled;
  timetables = [];

  user;
  state;
  workplace;

  // Timer
  timer;
  maxTime;
  timerActive: boolean;

  portrait;

  private lastTimetableSubscription;
  private stateSubscription;
  private timetablesSubscription;
  private workplaceSubscription;

  constructor(
    public alertCtrl: AlertController,
    public backgroundMode: BackgroundMode, 
    public loadingCtrl: LoadingController,
    public localNotifications: LocalNotifications,
    public navCtrl: NavController,
    public navParams: NavParams,
    public platform: Platform,
    public toastCtrl: ToastController,
    public checkProvider: CheckProvider,
    public globalVars: GlobalVars,
    public notificationProvider: NotificationProvider,
    public timetableProvider: TimetableProvider,
    public userProvider: UserProvider,
  ) {
    this.user = navParams.get('user');

    this.getUserInfo(this.user);
    // this.getWorkplace();
    if(this.user) this.activateTimer();

    this.portrait = window.innerHeight > window.innerWidth;
  }

  ionViewWillUnload() {
    if(this.lastTimetableSubscription && !this.lastTimetableSubscription.closed) this.lastTimetableSubscription.unsubscribe();
    if(this.stateSubscription && !this.stateSubscription.closed) this.stateSubscription.unsubscribe();
    if(this.timetablesSubscription && !this.timetablesSubscription.closed) this.timetablesSubscription.unsubscribe();
    if(this.workplaceSubscription && !this.workplaceSubscription.closed) this.workplaceSubscription.unsubscribe();
    clearTimeout(this.timer);
  }

  clickPause() {
    this.sendCheck('Pausa');
  }
  
  clickResume() {
    this.sendCheck('Reanudar');
  }
  
  clickStart() {
    this.sendCheck('Entrada');
  }

  clickStop() {
    this.sendCheck('Salida');
  }

  getUserInfo(user?) {
    if(!user) user = this.globalVars.user;

    // Consultar estat
    this.stateSubscription = this.userProvider.getState(user.key).subscribe(state => {
      this.state = state.value
      this.setButtonsState(this.state);
      this.setLastTimetable();
      if(this.globalVars.user.role != Role.checkPoint) this.notificationProvider.scheduleNotifications();
    });

    // Consultar horaris
    this.timetablesSubscription = this.userProvider.getTimetables(user.key).subscribe(timetables => {
      this.timetables = timetables;
      if(this.timetables.length == 1) {
        this.selectedTimetable = this.timetables[0].key
      }
      else if(this.timetables.length > 1) {
        this.lastTimetableSubscription = this.userProvider.getLastTimetable(user.key).subscribe(timetable => {
          this.lastTimetable = timetable.value;
          this.setLastTimetable();
        })
      }
    });
  }

  getWorkplace() {
    this.workplaceSubscription = this.userProvider.getUserWorkplace().subscribe(workplace => this.workplace = workplace);
  }


  activateTimer() {
    this.timer = setTimeout(x => {
      if(this.maxTime <= 0) { }
      this.maxTime -= 1;

      if(this.maxTime>0) this.activateTimer();
      else {
        console.log('timeout')
        this.navCtrl.popToRoot();
      }
    }, globalDefines.timerDelay);
  }

  private sendCheck(type) {
    if(this.selectedTimetable) {
      var loading = this.loadingCtrl.create({duration: globalDefines.loadingTimeoutCheck});
      loading.present();

      var user = this.user;
      if(!user) user = this.globalVars.user;

      this.checkProvider.createCheck(type, this.selectedTimetable, user, this.workplace).then(() => {
        loading.dismiss()
        if(this.user) this.navCtrl.pop();
      }).catch(error => {
        loading.dismiss()

        if(error == 'Lugar de fichaje desconocido.') {
          if(!user.strictGeolocalization) {
            this.alertCtrl.create({
              title: error,
              message: '¿Quiere proceder igualmente?',
              buttons: [
                {
                  text: 'No',
                  handler: () => {}
                },
                {
                  text: 'Sí',
                  handler: () => {
                    loading = this.loadingCtrl.create({duration: globalDefines.loadingTimeoutCheck});
                    loading.present();
                    
                    this.checkProvider.createInvalidCheck(type, this.selectedTimetable, user).then(() => {
                      loading.dismiss()
                      if(this.user) this.navCtrl.pop();
                      this.showMessage('Fichaje incorrecto enviado.')
                    }).catch(error => {
                      loading.dismiss()
                      this.showMessage(error)  
                    })
                  }
                }
              ]
            }).present();
          }
          else this.showMessage('Error: no tiene permiso para fichar desde un lugar desconocido.')
        }
        else this.showMessage(error);
      })
    }

    else {
      this.showMessage('Debe seleccionar un horario.')
    }
  }
  
  private setButtonsState(state?) {
    switch(state || this.globalVars.user.state) {
      case 'Entrada':
        this.startEnabled  = false;
        this.pauseEnabled  = true;
        this.resumeEnabled = false;
        this.stopEnabled   = true;
        break;

      case 'Pausa':
        this.startEnabled  = false;
        this.pauseEnabled  = false;
        this.resumeEnabled = true;
        this.stopEnabled   = false;
        break;

      case 'Reanudar':
        this.startEnabled  = false;
        this.pauseEnabled  = true;
        this.resumeEnabled = false;
        this.stopEnabled   = true;
        break;

      case 'Salida':
        this.startEnabled  = true;
        this.pauseEnabled  = false;
        this.resumeEnabled = false;
        this.stopEnabled   = false;
        break;
    }
  }

  private setLastTimetable() {
    if(this.lastTimetable && this.state != 'Salida') {
      this.selectedTimetable = this.lastTimetable;
    }
  }
  
  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}




// WEBPACK FOOTER //
// ./src/pages/home/home.ts